import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SignatureSizeMtoComponent } from './signature-size-mto/signature-size-mto.component';


const routes: Routes = [
  {
    path: 'signature-size',
    component: SignatureSizeMtoComponent,
    data: {
      title: "Tamaño firmas",
      breadcrumb: "Tamaño firmas"
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SignatureSizeMtoRoutingModule { }
